import React, { forwardRef } from "react";
import { Popover as MuiPopover } from "@mui/material";

const Popover = forwardRef(
  (
    { buttonLabel, children, anchorEl, setAnchorEl, trigger,sx={ pointerEvents: 'none' }, ...props },
    ref
  ) => {
    const isOpen = Boolean(anchorEl);
    const id = isOpen ? "common-popover" : undefined;

    const handleClick = (event) => {
      setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    // For hover
    const handleMouseEnter = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleMouseLeave = () => {
      setAnchorEl(null);
    };

    return (
      <div className="popover-container" onMouseLeave={trigger === "hover" ? handleMouseLeave : undefined}>
        <div
          ref={ref}
          aria-owns={isOpen ? "common-popover" : undefined}
          aria-haspopup="true"
          className="popover"
          aria-describedby="id"
          onClick={trigger === "click" ? handleClick : undefined}
          onMouseEnter={trigger === "hover" ? handleMouseEnter : undefined}
        >
          {buttonLabel}
        </div>
        <MuiPopover
          id="common-popover"
          open={isOpen}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          sx={sx}
          // slotProps={
          //   trigger === "hover"
          //     ? {
          //         paper: {
          //           onMouseEnter: () => setAnchorEl(anchorEl),
          //           onMouseLeave: () => setAnchorEl(null),
          //         },
          //       }
          //     : {}
          // }
          {...props}
        >
          <div className="popover-content">{children}</div>
        </MuiPopover>
      </div>
    );
  }
);

Popover.defaultProps = {
  trigger: "click",
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  disableRestoreFocus: true,
  elevation: 3,
  sx: { p: 1 },
};

export default Popover;
